import CryptoJS from "crypto-js";

const SECRET = "SECRET";
// const SECRET = process.env.REACT_APP_SECRET || "SECRET";

const SALT = CryptoJS.enc.Utf8.parse("fixed-salt-123456");
const IV = CryptoJS.enc.Hex.parse("00000000000000000000000000000000");

const KEY = CryptoJS.PBKDF2(SECRET, SALT, {
  keySize: 256 / 32,
  iterations: 1000,
});

export function createHash<T>(payload: T): string {
  return CryptoJS.AES.encrypt(JSON.stringify(payload), KEY, {
    iv: IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }).toString(); // full string
}

export function removeHash<T>(cipherText: string): T | null {
  try {
    const bytes = CryptoJS.AES.decrypt(cipherText.replace(/\s/g, ""), KEY, {
      iv: IV,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8)) as T;
  } catch (error) {
    console.error("Decryption failed:", error);
    return null;
  }
}
